<template>
  <div
    id="app"
    class="h-100"
    :class="[skinClasses]"
  >
    <b-modal
      title="Expired Session"
      v-model="promptSession"
      ok-title="OK"
      ok-only
      hide-header-close
      static
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      @ok="handleSessionExpired"
      @hide="preventSessionModalClose"
    >
      <p>Your session has expired. Choose OK to login again and continue.</p>
    </b-modal>

    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
// This will be populated in `beforeCreate` hook
// Trigger

import { dateFormatFull } from "@/utils/utils.js";
import {
  SESSION_SYNC_KEY,
  parseSessionSyncEvent,
  shouldInvalidateTab,
} from '@/utils/sessionSync'
import { $themeColors, $themeBreakpoints, $themeConfig } from '@themeConfig'
import { watch } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'

import { useWindowSize, useCssVar } from '@vueuse/core'

import store from '@/store'

// const LayoutVertical = () => import('@/layouts/vertical/LayoutVertical.vue')
const LayoutHorizontal = () => import('@/layouts/horizontal/LayoutHorizontal.vue')
const LayoutFull = () => import('@/layouts/full/LayoutFull.vue')
const LayoutCenter = () => import('@/layouts/center/LayoutCenter.vue')

export default {
  components: {

    // Layouts
    LayoutHorizontal,
    // LayoutVertical,
    LayoutFull,
    LayoutCenter,

  },
  data() {
    return {
      promptSession: false,
      isHandlingSessionExpiry: false,
      isLoggingOut: false,
      sessionUserId: null,
    }
  },
  created(){
    //temporary get current user
    //console.log('fetch user in app vue ')
    this.$store
      .dispatch('auth/fetchUser').
      then(x=>{
        //console.log(this.$store.getters['auth/getActiveUser'])
      })

    var now = new Date();
    console.info('current time ',dateFormatFull(now))
  },
  mounted() {
    this.sessionUserId = this.$session.get('userID')
    this.onStorageEvent = this.onStorageEvent.bind(this)
    window.addEventListener('storage', this.onStorageEvent)
  },
  beforeDestroy() {
    window.removeEventListener('storage', this.onStorageEvent)
  },
  methods: {
    onStorageEvent(event) {
      if (event.key !== SESSION_SYNC_KEY) {
        return
      }

      const payload = parseSessionSyncEvent(event)
      if (!shouldInvalidateTab(this.sessionUserId, payload) || this.isHandlingSessionExpiry) {
        return
      }

      this.isHandlingSessionExpiry = true
      this.promptSession = true
    },
    preventSessionModalClose(event) {
      if (!this.isLoggingOut) {
        event.preventDefault()
      }
    },
    handleSessionExpired() {
      this.isLoggingOut = true
      const logData = this.$session.get('userID')
        ? {
          id: this.$session.get('userID'),
          message: 'Logged Out Automatically',
        }
        : {
          email: 'noname@rsp.com',
          message: '[USER ID NOT FOUND] - Logged Out Automatically',
          name: 'noname',
        }

      this.$store.dispatch('log/addLog', logData).finally(() => {
        this.$session.clear()
        this.$session.destroy()
        window.location.reload()
      })
    },
  },
  // ! We can move this computed: layout & contentLayoutType once we get to use Vue 3
  // Currently, router.currentRoute is not reactive and doesn't trigger any change
  computed: {
    layout() {
      // if (this.$route.meta.layout === 'full') return 'layout-full'
      // return `layout-${this.contentLayoutType}`
      return 'layout-full'
    },
    contentLayoutType() {
      return this.$store.state.appConfig.layout.type
    },
  },
  beforeCreate() {
    // Set colors in theme
    const colors = ['primary', 'secondary', 'success', 'info', 'warning', 'danger', 'light', 'dark']

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = colors.length; i < len; i++) {
      $themeColors[colors[i]] = useCssVar(`--${colors[i]}`, document.documentElement).value.trim()
    }

    // Set Theme Breakpoints
    const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl']

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = breakpoints.length; i < len; i++) {
      $themeBreakpoints[breakpoints[i]] = Number(useCssVar(`--breakpoint-${breakpoints[i]}`, document.documentElement).value.slice(0, -2))
    }

    // Set RTL
    const { isRTL } = $themeConfig.layout
    document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr')
  },
  setup() {
    const { skin, skinClasses } = useAppConfig()

    // If skin is dark when initialized => Add class to body
    if (skin.value === 'dark') document.body.classList.add('dark-layout')

    // Set Window Width in store
    store.commit('app/UPDATE_WINDOW_WIDTH', window.innerWidth)
    const { width: windowWidth } = useWindowSize()
    watch(windowWidth, val => {
      store.commit('app/UPDATE_WINDOW_WIDTH', val)
    })

    return {
      skinClasses,
    }
  },
}
</script>
